/**
 * Number of ticks/labels to render on the date x-axis of the performance
 * charts. Capping this keeps the labels evenly spaced and prevents
 * crowding when there are many data points.
 */
export const CHART_DATE_TICK_AMOUNT = 6;

/**
 * Formats a chart x-axis category (a millisecond timestamp passed as a string)
 * into a two-line label: "<day> <month>" on the first line and the year on the
 * second, e.g. ["17 Apr", "2026"].
 */
export const formatChartDateAxisLabel = (value: string): string[] => {
  const date = new Date(Number(value));
  return [`${date.getDate()} ${date.toLocaleDateString("en-US", { month: "short" })}`, `${date.getFullYear()}`];
};
